import { render, staticRenderFns } from "./WtkSelect.vue?vue&type=template&id=017053b5"
import script from "./WtkSelect.vue?vue&type=script&lang=js"
export * from "./WtkSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports